var varsPos = "\n    attribute vec2 aVertexPosition;\n    uniform mat3 projectionMatrix;\n    uniform mat3 translationMatrix;\n";
var varsUV = "\n    attribute vec2 aUvs;\n    varying vec2 vUvs;\n";
// function snippets
var funStart = "\n    void main() {\n";
var funUV = "\n    vUvs = aUvs;\n";
var funEnd = "\n    }\n";
export var transformVertexSrc = function (includeUv, transformCount) {
    if (includeUv === void 0) { includeUv = false; }
    if (transformCount === void 0) { transformCount = 2; }
    var varsTrans = "\n        attribute float aWeight;\n        uniform vec2 transforms[".concat(transformCount, "];\n        uniform vec2 scales[").concat(transformCount, "];\n        uniform vec2 scaleAnchors[").concat(transformCount, "];\n    ");
    var funTrans = "\n        int transformIndex = int(aWeight);\n        vec2 vertexOffset = transforms[transformIndex]; // here we actually translate or move the vertex -- rename?\n        \n        // scale vertex from scale anchor position using scale value\n        vec2 vertexScale = scales[transformIndex];\n        mat3 scaleMatrix = mat3(vertexScale.x, 0, 0, 0, vertexScale.y, 0, 0, 0, 1);\n        vec2 vertexScaleAnchor = scaleAnchors[transformIndex];\n        mat3 scaleAnchorMatrix = mat3(1, 0, 0, 0, 1, 0, vertexScaleAnchor.x, vertexScaleAnchor.y, 1);\n        mat3 invScaleAnchorMatrix = mat3(1, 0, 0, 0, 1, 0, -vertexScaleAnchor.x, -vertexScaleAnchor.y, 1);\n        \n        // translate vertex using transform value\n        vec2 vertexPosition = aVertexPosition + vertexOffset;\n        \n        vec3 inbetweenPosition = scaleAnchorMatrix * scaleMatrix * invScaleAnchorMatrix * vec3(vertexPosition, 1.0);\n        gl_Position = vec4((projectionMatrix * translationMatrix * inbetweenPosition).xy, 0.0, 1.0);\n    ";
    // assemble
    var shader;
    shader = varsPos;
    if (includeUv) {
        shader += varsUV;
    }
    shader += varsTrans;
    shader += funStart;
    if (includeUv) {
        shader += funUV;
    }
    shader += funTrans;
    shader += funEnd;
    return shader;
};
export var deformVertexSrc = function (includeUv) {
    if (includeUv === void 0) { includeUv = false; }
    var varsCurve = "\n        uniform sampler2D texture;\n        uniform float pathOffset;\n        uniform float pathSegment;\n        uniform float spineOffset;\n        uniform float spineLength;\n        uniform int flow;\n        float textureLayers = 4.; // look up takes (i + 0.5) / textureLayers\n    ";
    var funCurve = "\n        vec4 worldPos = vec4(aVertexPosition.xy, 0.0, 1.0);\n        bool bend = flow > 0;\n        float xWeight = bend ? 0.0 : 1.0;\n        float spinePortion = bend ? (worldPos.x + spineOffset) / spineLength : 0.;\n        float mt = spinePortion * pathSegment + pathOffset;\n        \n        vec3 spinePos = texture2D(texture, vec2(mt, (0.5) / textureLayers)).xyz;\n        vec3 a = texture2D(texture, vec2(mt, (1. + 0.5) / textureLayers)).xyz;\n        vec3 b = texture2D(texture, vec2(mt, (2. + 0.5) / textureLayers)).xyz;\n        vec3 c = vec3(0.0, 0.0, 1.0);\n        mat3 basis = mat3(a, b, c);\n        \n        vec3 transformed = basis\n                * vec3(worldPos.x * xWeight, worldPos.y * 1., 0)\n                + spinePos;\n        gl_Position = vec4((projectionMatrix * translationMatrix * vec3(transformed.xy, 1.0)).xy, 0.0, 1.0);\n    ";
    // assemble
    var shader;
    shader = varsPos;
    if (includeUv) {
        shader += varsUV;
    }
    shader += varsCurve;
    shader += funStart;
    if (includeUv) {
        shader += funUV;
    }
    shader += funCurve;
    shader += funEnd;
    return shader;
};
export var simpleVertexSrc = function (includeUv) {
    if (includeUv === void 0) { includeUv = false; }
    // function
    var funPos = "\n        gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    ";
    // assemble
    var shader;
    shader = varsPos;
    if (includeUv) {
        shader += varsUV;
    }
    shader += funStart;
    shader += funPos;
    if (includeUv) {
        shader += funUV;
    }
    shader += funEnd;
    return shader;
};
